// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../types';
import type { ColorScheme } from '../../../../types/theme';

type Props = {
  className?: string, // eslint-disable-line react/require-default-props
  index: number, // eslint-disable-line react/no-unused-prop-types
  scheme: ColorScheme,
};

const StyledNumber = styled<any, Theme, Props>('div')`
  margin-top: -0.1em;
  position: relative;
  text-align: center;
  width: ${({ theme }) => theme.list.listStyles.size};

  &:before {
    border: 1px solid ${({ scheme, theme }) => scheme.icons || theme.list.listStyles.numbered.color};
    border-radius: 50%;
    color: ${({ scheme, theme }) => scheme.icons || theme.list.listStyles.numbered.color};
    content: '${({ index }) => index}';
    display: block;
    font-size: ${({ theme }) => theme.list.listStyles.numbered.fontSize};
    font-weight: 600;
    height: ${({ theme }) => theme.list.listStyles.numbered.circleSize};
    line-height: ${({ theme }) => theme.list.listStyles.numbered.circleSize};
    overflow: hidden;
    position: absolute;
    width: ${({ theme }) => theme.list.listStyles.numbered.circleSize};
  }
`;

const Numbered = ({ scheme, index, className }: Props) => (
  <StyledNumber
    scheme={scheme}
    className={className}
    index={index}
  />
);

export default Numbered;
